import { render, staticRenderFns } from "./UserSecurity.vue?vue&type=template&id=2ba2cd59&"
import script from "./UserSecurity.vue?vue&type=script&lang=ts&"
export * from "./UserSecurity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports